/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */
/* eslint-disable consistent-return */
import { Buffer } from 'buffer';
import _ from 'lodash';

import apolloClient from '../../../core/backendClient/apolloClient';
import Schemas from './graphql';

/**
 * @param {String} storeId
 * @param {String} type
 * @returns {Promise<TemplateEmail | null>}
 */
async function getTemplateEmail({ storeId, type }) {
  const res = await apolloClient.query({
    query: Schemas.GET_TEMPLATE_EMAIL,
    variables: { storeId, type },
    fetchPolicy: 'network-only',
  });
  if (res.data.getTemplateEmail && res.data.getTemplateEmail.code === 200) {
    return {
      ...res.data.getTemplateEmail.templateEmail,
      html:
        res.data.getTemplateEmail.templateEmail.html !== null
          ? Buffer.from(
              res.data.getTemplateEmail.templateEmail.html,
              'base64',
            ).toString('utf-8')
          : null,
    };
  }
  return null;
}

/**
 * @param {String} storeId
 * @param {Partial<TemplateEmail>} templateEmail
 * @returns {Promise<TemplateEmail | null>}
 */
async function upsertTemplateEmail({ storeId, templateEmail }) {
  const processedTemplateEmail = {
    ...templateEmail,
    html: Buffer.from(templateEmail.html, 'utf-8').toString('base64'),
  };
  if (processedTemplateEmail.storeId) {
    delete processedTemplateEmail.storeId;
  }
  if (processedTemplateEmail.__typename) {
    delete processedTemplateEmail.__typename;
  }
  const res = await apolloClient.mutate({
    mutation: Schemas.UPSERT_TEMPLATE_EMAIL,
    variables: {
      storeId,
      templateEmail: processedTemplateEmail,
    },
  });
  if (
    res.data.upsertTemplateEmail &&
    res.data.upsertTemplateEmail.code === 200
  ) {
    return {
      ...res.data.upsertTemplateEmail.upsertedTemplateEmail,
      html:
        res.data.upsertTemplateEmail.upsertedTemplateEmail.html !== null
          ? Buffer.from(
              res.data.upsertTemplateEmail.upsertedTemplateEmail.html,
              'base64',
            ).toString('utf-8')
          : null,
    };
  }
  return null;
}

/**
 * @param {String} storeId
 * @param {Partial<EmailsPreferneces>} emailsPreferences
 * @returns {Promise<EmailsPreferences | null>}
 */
async function upsertEmailsPreferences({ storeId, emailsPreferences }) {
  const copyObj = _.cloneDeep(emailsPreferences);
  if (copyObj.__typename) {
    delete copyObj.__typename;
  }
  if (!copyObj.storeId) {
    copyObj.storeId = storeId;
  }
  const res = await apolloClient.mutate({
    mutation: Schemas.UPSERT_EMAILS_PREFERENCES,
    variables: {
      preferences: copyObj,
    },
  });
  if (
    res.data.upsertEmailsPreferences &&
    res.data.upsertEmailsPreferences.code === 200
  ) {
    return res.data.upsertEmailsPreferences.preferences;
  }
  return null;
}

/**
 * @param {String} storeId
 * @returns {Promise<EmailsPreferences | null>}
 */
async function getEmailsPreferences({ storeId }) {
  const res = await apolloClient.mutate({
    mutation: Schemas.GET_EMAILS_PREFERENCES,
    variables: { storeId },
  });
  if (
    res.data.getEmailsPreferences &&
    res.data.getEmailsPreferences.code === 200
  ) {
    return res.data.getEmailsPreferences.preferences;
  }
  return null;
}

export default {
  getTemplateEmail,
  upsertTemplateEmail,
  upsertEmailsPreferences,
  getEmailsPreferences,
};
